import BalanceFill from '@/assets/icons/balance_fill.svg?component';
import Heartbeat2Fill from '@/assets/icons/heartbeat_2_fill.svg?component';
import LayoutGridFill from '@/assets/icons/layout_grid_fill.svg?component';

import { cageLiceItem } from './cageLiceItem';
import type { SidebarItemConfig } from './types';

/** The cage level's dashboard, weight, lice and welfare entries, in sidebar order. */
export const cageMonitoringItems: SidebarItemConfig[] = [
    {
        id: 'cage-dashboard',
        label: 'sidebarItems.shared.dashboard',
        analyticsLabel: 'Dashboard',
        path: '/dashboard',
        icon: LayoutGridFill,
        exact: true,
        children: [
            {
                id: 'cage-dashboard-images',
                label: 'sidebarItems.cageLevel.images',
                analyticsLabel: 'Images',
                path: '/dashboard/images',
                exact: true,
            },
            {
                id: 'cage-dashboard-graphs',
                label: 'sidebarItems.cageLevel.graphs',
                analyticsLabel: 'Graphs',
                path: '/dashboard/graphs',
                exact: true,
            },
            {
                id: 'cage-dashboard-bioscope',
                label: 'sidebarItems.cageLevel.bioscopeStatus',
                analyticsLabel: 'Bioscope status',
                path: '/dashboard/bioscope',
                exact: true,
            },
        ],
    },
    {
        id: 'cage-weight',
        label: 'sidebarItems.cageLevel.weight',
        analyticsLabel: 'Weight',
        path: '/weight',
        icon: BalanceFill,
        exact: true,
        children: [
            {
                id: 'cage-weight-distribution',
                label: 'sidebarItems.cageLevel.weightDistribution',
                analyticsLabel: 'Weight distribution',
                path: '/weight/distribution',
                exact: true,
            },
            {
                id: 'cage-weight-growth',
                label: 'sidebarItems.cageLevel.growth',
                analyticsLabel: 'Growth',
                path: '/weight/growth',
                exact: true,
            },
            {
                id: 'cage-weight-graphs',
                label: 'sidebarItems.cageLevel.graphs',
                analyticsLabel: 'Graphs',
                path: '/weight/graphs',
                exact: true,
            },
        ],
    },
    cageLiceItem,
    {
        id: 'cage-welfare',
        label: 'sidebarItems.cageLevel.welfare',
        analyticsLabel: 'Welfare',
        path: '/welfare',
        icon: Heartbeat2Fill,
        exact: true,
        visibility: {
            requiresLicenses: ['FISH_HEALTH.MIN'],
            requiresBioscopeV1: true,
        },
        children: [
            {
                id: 'cage-welfare-wounds',
                label: 'sidebarItems.cageLevel.woundInsight',
                analyticsLabel: 'Wound insight',
                path: '/welfare/wounds',
                exact: false,
                visibility: {
                    requiresLicenses: ['FISH_HEALTH.MIN'],
                    requiresBioscopeV1: true,
                },
                navigatesToSubLevel: true,
            },
            {
                id: 'cage-welfare-scaleloss',
                label: 'sidebarItems.cageLevel.scaleloss',
                analyticsLabel: 'Scaleloss',
                path: '/welfare/scaleloss',
                exact: true,
                visibility: {
                    requiresLicenses: ['FISH_HEALTH.MIN'],
                    requiresNonSmolt: true,
                    requiresBioscopeV1: true,
                },
            },
            {
                id: 'cage-welfare-maturation',
                label: 'sidebarItems.cageLevel.maturation',
                analyticsLabel: 'Maturation',
                path: '/welfare/maturation',
                exact: true,
                visibility: {
                    requiresLicenses: ['FISH_HEALTH.MIN'],
                    requiresNonSmolt: true,
                    requiresBioscopeV1: true,
                },
            },
            {
                id: 'cage-welfare-maturation-detections',
                label: 'sidebarItems.cageLevel.detectionsMaturation',
                analyticsLabel: 'Detections maturation',
                path: '/welfare/maturation/detections',
                exact: true,
                visibility: {
                    requiresLicenses: ['FISH_HEALTH.MIN'],
                    requiresNonSmolt: true,
                    requiresBioscopeV1: true,
                },
            },
            {
                id: 'cage-welfare-fish-speed',
                label: 'sidebarItems.cageLevel.fishSpeed',
                analyticsLabel: 'Fish Speed',
                path: '/welfare/speed',
                exact: true,
                // Fish Speed is the legacy fallback for users without the Behavior module.
                // Hidden when the BEHAVIOR license is active.
                // TODO: Remove hasNoLicenses when FISH_SPEED license is removed.
                visibility: {
                    requiresLicenses: ['FISH_SPEED'],
                    requiresNonSmolt: true,
                    requiresBioscopeV1: true,
                    hasNoLicenses: ['BEHAVIOR'],
                },
            },
        ],
    },
];
